/*
 * Copyright Evollis 2021
 * All Rights Reserved.
 *
 * All information contained herein is, and remains the property of Evollis.
 * The intellectual and technical concepts contained herein are
 * proprietary to Evollis and are protected by trade secret and copyright law.
 * Dissemination of this information or reproduction of this material
 * is STRICTLY FORBIDDEN unless prior written permission is obtained
 * from Evollis.
 */
import { extractList } from "../core/service/BusinessLogicService"
import { loc } from "../core/utils"
import {
  prioritizeFranceInCountrySelectOptions,
  tenantPrioritizesFranceInCountrySelect
} from "../service/CountryService"
import TextField from "./TextField"
import axios from "axios"
import React, { useEffect, useState } from "react"
import { Form, FormGroup } from "react-bootstrap"
import { Field as FinalFormField } from "react-final-form"
import Select, { createFilter } from "react-select"

export default function (props) {
  const {
    label,
    hidden,
    name,
    disabled,
    placeholder,
    options,
    inputmode,
    url,
    token,
    extract,
    oneElement,
    enableMatchLabel,
    clearIfNotExists = true,
    tenant,
    ...rest
  } = props

  const [values, setValues] = useState(options)

  useEffect(() => {
    let mounted = true

    if (!options) {
      if (url) {
        axios
          .get(url, {
            headers: { Authorization: `Bearer ${token}`, Accept: "*/*" }
          })
          .then((response) => {
            if (mounted && response) {
              let list = extract ? extract(response.data) : extractList(response.data)
              if (name === "identity.birthCountry" && tenantPrioritizesFranceInCountrySelect(tenant)) {
                list = prioritizeFranceInCountrySelectOptions(list)
              }
              setValues(list)
            }
          })
      } else {
        setValues(null)
      }
    }
    return function cleanup() {
      mounted = false
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options, url])

  if (hidden) {
    return null
  }

  return values?.length > 0 ? (
    <FinalFormField name={name} type="text" placeholder={placeholder} className="form-control">
      {({ input, meta }) => {
        const metaError = (meta.error || meta.submitError) && meta.touched

        // The value is either stored into value.value (maually case) or directly in value (what the back end sends)
        const value = input.value?.value || input.value

        // The value should match either the value of the option or its label (backend send birthCity as a Text that's why we match the label too)
        const optionById = values?.filter(
          (key) =>
            (key.value === value && value !== "") ||
            (enableMatchLabel && key?.label?.toUpperCase().match(value.toUpperCase()) && value !== "") ||
            (oneElement && values?.length === 1)
        )

        // To make sure that the selected option body in the code is the same as the selected one on the interface
        if (optionById[0]?.value !== value?.value || optionById[0]?.label !== value?.label) {
          input.onChange(optionById[0])
        }

        // clear if value not in values
        if (value && optionById.length === 0 && clearIfNotExists) {
          input.onChange(null)
        }

        // Filter only on label configuration
        const filterConfig = {
          ignoreCase: true,
          ignoreAccents: true,
          matchFrom: "any",
          stringify: (option) => `${option.label}`,
          trim: true
        }

        return (
          <FormGroup>
            <div className="d-flex" style={name === "budget.numberMonthsIncome" && label === " " ? {height: "23.97px"} : {}}>
              {label && <Form.Label className="form-label">{label}</Form.Label>}
            </div>
            <Select
              {...input}
              classNamePrefix="react-select"
              className={metaError && "selectfield-error"}
              value={optionById}
              isDisabled={((disabled || oneElement) && values?.length === 1) || disabled}
              placeholder={loc`Select...`}
              options={values}
              isClearable
              inputId={`select-${name}`}
              onChange={(option) => {
                input.onChange(option)
              }}
              filterOption={createFilter(filterConfig)}
              captureMenuScroll={false}
              {...rest}
            />
            {metaError && !(oneElement && values.length === 1) && (
              <p className="required-message">{meta.error || meta.submitError}</p>
            )}
          </FormGroup>
        )
      }}
    </FinalFormField>
  ) : (
    <TextField
      name={name}
      label={label}
      trimOnBlur={true}
      disabled={disabled}
      inputMode={inputmode ? inputmode : null}
    />
  )
}
